import { ProgramType } from '../../program/types';
import { DivButton } from '../../commons/components/DivButton';
import { PlusIcon } from '../../assets/icons';
import React from 'react';
import { defaultColors } from '../../commons/constants';

const ProgramTypeRow = (props: { programType: ProgramType; onUpdate: () => void }) => (
  <div
    className="program-types__item-container"
    data-test="program-type-row"
    key={props.programType.id}
    onClick={props.onUpdate}
    role="button"
    tabIndex={0}
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        props.onUpdate();
      }
    }}
  >
    <div
      className="program-type-row__color"
      data-test={`program-type-row__color--${props.programType.color}`}
      style={{ backgroundColor: props.programType.color }}
    />

    <div
      className="growegy-label14 text-truncate"
      data-test={`program-type-row__label-${props.programType.name.replace(/ /g, '-')}`}
    >
      {props.programType.name}
    </div>
  </div>
);

export const ProgramTypesList = (props: {
  data: ProgramType[];
  onUpdate: (user: ProgramType) => void;
  onCreate: (user: ProgramType) => void;
}) => {
  const { data, onUpdate, onCreate } = props;
  return (
    <>
      <div className="program-type-body">
        {data.map((d) => (
          <ProgramTypeRow key={d.id} programType={d} onUpdate={() => onUpdate(d)} />
        ))}
      </div>
      <DivButton
        icon={<PlusIcon />}
        onClick={() => onCreate({ id: '', name: '', color: defaultColors[0], role: null })}
        text="Add new"
        dataTest="program-type__add-new-row"
        className="program-type__add-new-btn"
      />
    </>
  );
};
